import { defineMessages } from 'react-intl'

export default defineMessages({
  caption: {
    id: 'components.ChildVoiceCard.caption',
    defaultMessage: "<b>Tiny voices, big potential!</b> Children voices evolve so fast, so we'll make sure to get back to you with fresh new demos, for you to review.",
  }
})
